import broadcast from "../../app/broadcast";
import http from "../../app/http";
import trans from "../../app/trans";
import store from "../../app/store";
import rootScope from "../../app/rootScope";


/**
 * Clase que controla la lógica de la ventana de alertas.
 * @class
 */
class WarningsWindowController{

    /**
     * Constructor de la clase WarningsWindowController.
     * @constructor
     * @param {WarningsWindowView} view - Instancia de la vista de la ventana de alertas.
     */
    constructor(view) {

        /**
         * Vista asociada al controlador.
         * @type {WarningsWindowView}
         * @private
         */
        this.view = view;

        // Vincula la notificación de la vista al controlador.
        this.view.bindNotify(this.notify);

        // Escucha el evento para pintar los detalles de alertas.
        broadcast.on("warningdetail",(group, day, filter)=>{
            this.detailWarning(group, day, filter);
        })

        broadcast.on("backPressed", ()=>{
            if (this.view.isOpen())
                this.view.close();
        })

    }

    /**
     * Método asíncrono para mostrar detalles de un grupo de alertas específico.
     * @param {string} group - Identificador del grupo de alertas.
     * @param {number} day - Día para el que se muestran las alertas.
     * @param {boolean[]} filter - Filtros de alertas.
     * @async
     * @private
     */
    async detailWarning(group, day, filter){
        const lang = store.get("usedLang");
        const langarray = lang.split('_');

        // Obtiene la info de los detalles del grupo de alertas
        const response = await http.get(`${rootScope.alertsServer}/group/${group}/${langarray[0]}/`);

        if (response.status === 200){
            // Se actualiza la vista de la ventana y se abre
            this.view.update(response.data.data, day, trans, lang.replace("_", "-"), (rootScope.resourcesServer ? rootScope.resourcesServer  : ""), filter );
            this.view.open();
        }

    }


    /**
     * Método que notifica la apertura o cierre de la ventana de alertas.
     * @param {boolean} open - Estado de apertura de la ventana.
     * @private
     */
    notify(open){
        // Lanza eventos según el estado de apertura de la ventana.
        if (open){
            const event = new Event('overlayMenuOpened');
            document.dispatchEvent(event);
        }else{
            const event = new Event('overlayMenuClosed');
            document.dispatchEvent(event);
        }

        // Almacena el estado de apertura de la ventana.
        store.set("openMenus", open);
    }
}

export default WarningsWindowController;
